import React, { useEffect, useState } from 'react'
import { ajaxGet, ajaxPut } from '../../ajax'

export default function Popup({eventId, eventIndex, doneCount, onEnter, onLeave, onTodoChange}) {
  const [todos, setTodos] = useState([])

  useEffect(() => {
    let isMounted = true
    ajaxGet(`/admins/reservations/${eventId}/todos.json`, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => { if (response.ok) return response.json() })
    .then((json) => {
      isMounted && setTodos(json)
    }) 

    return () => { isMounted = false }
  }, [])

  const changeTodoState = (todoId, checked, todoIndex) => {
    const data = { todo: { done: checked } }

    ajaxPut('/admins/reservations/' + eventId + '/todos/' + todoId, data)
    .then(response => response.json())
    .then(json => {
      const newTodos = [
        ...todos.slice(0, todoIndex), 
        json,
        ...todos.slice(todoIndex + 1, todos.length)
      ]
      setTodos(newTodos)
      const newDoneCount = checked ? doneCount + 1 : doneCount - 1
      onTodoChange({ eventIndex, newDoneCount })
    })
  }

  return <div className='popup' onMouseEnter={onEnter} onMouseLeave={onLeave}>
    <div className='popup-todo-list'>
      {
        todos.map((todo, index) => { 
          return <div key={todo.id}>
            <label className={todo.done ? 'done' : ''}>
              <input 
                type='checkbox' 
                checked={todo.done} 
                onChange={(e) => changeTodoState(todo.id, e.target.checked, index)}
              />
              <span>&nbsp;{todo.description}</span>
            </label>
          </div> 
        })
      }
    </div>
  </div>
}
